// extracted by mini-css-extract-plugin
export default {"detail_pop":"detail_pop--eBccl","detail_pic":"detail_pic--_8qyM","detail_text":"detail_text--e2dHa","detail_title":"detail_title--yKWjf","detail_desc":"detail_desc--EKDq7"};